<template>
  <e-sidebar
    id="sidebar-form-add-permit-license"
    :title="$t('Novo documento')"
    :show="showSidebar"
    :saving="saving"
    width="500px"
    @save="handlePermitLicenseSave"
    @hidden="onHideSidebar"
  >
    <template #content>
      <FormulateForm
        ref="permitLicenseSidebarForm"
        name="permitLicenseSidebarForm"
      >
        <FormulateInput
          v-model="permitLicenseForm.permitLicenseType"
          type="vue-select"
          validation="required"
          class="required"
          :label="$t('Tipo de documento')"
          :options="permitLicensesTypes()"
          :placeholder="$t('Selecione')"
          :disabled="saving"
        />
        <FormulateInput
          id="permit-license-document"
          v-model="permitLicenseForm.permitLicenseDocument"
          type="uploader"
          deletable="true"
          max-files="1"
          accept=".pdf"
          validation="required"
          class="required"
          :disabled="saving"
          :help-text="$t('Arraste e solte o documento aqui')"
          :delete-confirm-message="$t('Tem certeza que deseja excluir o Documento?')"
          :meta="false"
          :label="$t('Documento')"
        />
        <FormulateInput
          v-model="permitLicenseForm.dueDate"
          type="datepicker"
          validation="required"
          class="required"
          :placeholder="$t('dd/mm/aaaa')"
          :label="$t('Data de Vencimento')"
          :disabled="saving"
        />
        <template v-if="showObservation">
          <FormulateInput
            v-model="permitLicenseForm.observation"
            :label="$t('Observação')"
            type="textarea"
            :disabled="saving"
          />
        </template>
      </FormulateForm>
    </template>
  </e-sidebar>
</template>

<script>
import ESidebar from '@/views/components/ESidebar.vue'
import { companyDomains, uploader } from "@/mixins"
import { mapActions, mapState } from 'vuex'

export default {
  name: "PermitLicensesSidebar",
  components: {
    ESidebar,
  },
  mixins: [companyDomains, uploader],
  props: {
    isEdition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSidebar: false,
      saving: false,
    }
  },
  computed: {
    ...mapState('pages/company/companyMaintain', {
      company: 'company',
      permitLicenseForm: 'permitLicenseForm'
    }),
    showObservation() {
      return this.permitLicenseForm.permitLicenseType === 'PropertyTax'
    }
  },
  watch: {
    'permitLicenseForm.permitLicenseType': function clearObservation() {
      this.permitLicenseForm.observation = null
    }
  },
  methods: {
    ...mapActions('pages/company/companyMaintain', [
      'addPermitLicense',
      'addPermitLicenseLocal',
      'resetPermitLicenseForm',
    ]),
    async onAddPermitLicense() {
      try {
        this.saving = true
        const uploadPermitLicenseResult = await this.upload({
          files: [...this.permitLicenseForm.permitLicenseDocument],
          destinationPath: `company/permit-licenses/CompanyId=${this.company.id}`,
        })

        await this.addPermitLicense({
          dueDate: this.permitLicenseForm.dueDate,
          permitLicenseType: this.permitLicenseForm.permitLicenseType,
          observation: this.permitLicenseForm.observation,
          companyId: this.company.id,
          documentUrl: uploadPermitLicenseResult.length
            ? uploadPermitLicenseResult[0].url
            : null,
        })

        this.showSuccess(this.$t('Documento cadastrado com sucesso'))
      } catch (error) {
        this.showError(error)
      } finally {
        this.saving = false
        this.hidden()
      }
    },
    onAddPermitLicenseInternally() {
      try {
        this.addPermitLicenseLocal({
          dueDate: this.permitLicenseForm.dueDate,
          permitLicenseType: this.permitLicenseForm.permitLicenseType,
          observation: this.permitLicenseForm.observation,
          permitLicenseDocument: [...this.permitLicenseForm.permitLicenseDocument],
        })

        this.showSuccess(this.$t('Documento adicionado à lista'))
      } catch (error) {
        this.showError(error)
      } finally {
        this.hidden()
      }
    },
    handlePermitLicenseSave() {
      const hasValidExtension = this.permitLicenseForm.permitLicenseDocument[0]?.ext === 'pdf'
      if(!hasValidExtension) {
        this.showError({
          title: this.$t('Extensão inválida'),
          message: this.$t(
            'O documento deve estar no formato PDF.'
          ),
        })

        return
      }

      if(this.$refs.permitLicenseSidebarForm.hasErrors) {
        this.$refs.permitLicenseSidebarForm.showErrors()

        this.showError({
          title: this.$t('Dados inválidos'),
          message: this.$t(
            'Dados inválidos, verifique!'
          ),
        })

        return
      }

      if (this.isEdition) {
        this.onAddPermitLicense()
      } else {
        this.onAddPermitLicenseInternally()
      }
    },
    show() {
      this.cleanSidebar()
      this.showSidebar = true
    },
    hidden() {
      this.cleanSidebar()
      this.showSidebar = false
    },
    onHideSidebar() {
      this.hidden()
    },
    cleanSidebar() {
      this.resetPermitLicenseForm()
    }
  }
}
</script>
